import TypeService from "src/services/TypeService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {};
export const params = {
	name: "",
	min_questions:0,
	organizations: [],
	allowed_questions:[],
	description: "",
	logo: "",

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.type,
@property  {array}  modules.types
 **/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	types: types,
};
export default ModuleCreator("type", TypeService, module, types, params);
